import { render, staticRenderFns } from "./QNAManagementDetail.vue?vue&type=template&id=0e8a0e89&scoped=true"
import script from "./QNAManagementDetail.vue?vue&type=script&lang=js"
export * from "./QNAManagementDetail.vue?vue&type=script&lang=js"
import style0 from "./QNAManagementDetail.vue?vue&type=style&index=0&id=0e8a0e89&prod&scoped=true&lang=scss"
import style1 from "./QNAManagementDetail.vue?vue&type=style&index=1&id=0e8a0e89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8a0e89",
  null
  
)

export default component.exports